import { ControllerFieldState } from 'react-hook-form';

export const mapTextFieldErrorProps = (
  fieldState: ControllerFieldState,
): { error: boolean; helperText?: string } => ({
  error: fieldState.isTouched && !!fieldState.error,
  // helperText: fieldState.error?.message,
  // FormHelperTextProps={{ style: { position: 'absolute', bottom: -18, color: COLORS.error } }}
});
